export enum ThemeFontProperties {
    fontFamily = 'fontFamily',
    fontSize = 'fontSize',
    fontWeight = 'fontWeight',
    fontStyle = 'fontStyle',
    lineHeight = 'lineHeight',
    textTransform = 'textTransform',
    letterSpacing = 'letterSpacing',
    color = 'color',
}
